import {useState,useEffect,useContext} from 'react'
import { getAll } from '../../Data/Utils';
import { getTlvLink,buildItemsList,getUrlField } from '../../Data/GeneralFanction';
import { LanguageContext } from '../../context';

// import './SocialFooter.css'

const SocialFooter = () => {

    const [socialFooterData,setSocialFooterData]=useState([]);
    const { language } = useContext(LanguageContext);
    

    useEffect(()=>{
        const getData = async () => {
            var webUrl=window.srcSiteUrl;//process.env.REACT_APP_APIURL;
            if(language=="en")
                webUrl=webUrl+"/"+language;
            var apiUrl=config.apiUrl;
            const extraNavList=config.lists.extraNav.name; 
            const view=config.lists.extraNav.view;
            let { data: socialFooter } = await getAll(`${webUrl}${apiUrl}?listName=${extraNavList}&view=${view}`);
            var x=buildItemsList(socialFooter);
            for (var i=0;i<x.length;i++){
                if(x[i].longURL.Value !== ''){
                    x[i].tlvLink = getTlvLink(x[i].longURL.Value);
                }               
            }
            setSocialFooterData(x) ;
        };
      var config = require('../../config.json');
      getData();       
      
      },[language]);



  return (
   
        <ul className='footericons'>
        {
            socialFooterData.map((item,index)=>{
                return  <li key={index}>{ item.tlvLink!=undefined && <a href={item.tlvLink.Url} target={item.tlvLink.Target}><img src={getUrlField(item.pcIcon.Value).Url} alt={getUrlField(item.pcIcon.Value).Caption}></img></a>}</li>
            })
        }
        </ul>
   
  )
}

export default SocialFooter